import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';
import { GlobalVariables } from 'app/services/globals';
import { UpdateMethod } from 'shell-models-lib';
import { getAppendOption } from '../consts/copy-job-const';
import { writeBehaviorAllOptions, writeBehaviorOptionValues } from 'app/shared/constants/write-behavior.const';

export const amazonRedshiftTableMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.amazonRedshift.datasetType,
    displayName: stringResources.AmazonRedshift_DisplayText,
    supportLinkedServiceTypes: [adfModelTypeMap.amazonRedshift.linkedServiceType],
    isSource: true,
    isSink: GlobalVariables.enableAmazonRedshiftSink,
    datasetKind: 'table',
    showWarningMessage: '{ linkedService && linkedService.version !== "v2" }',
        warningMessage: format(
            stringResources.Dataset_Legacy_IsNotSupportedWarning_alt3,
            stringResources.VersionLabel.toLocaleLowerCase()
        ),
        warningMessageHyperlink: 'https://learn.microsoft.com/azure/data-factory/connector-amazon-redshift',
    icon: {
        className: 'svg-i-100x100-AmazonRedshift'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    splitTablePath: true,
    copySinkControls: GlobalVariables.enableAmazonRedshiftSink ? [
        {
            type: 'parameterizable-dropdown',
            bind: 'writeBehavior',
            label: stringResources.ModelName_WriteBehavior,
            isLabelVertical: false,
            defaultValue: writeBehaviorOptionValues.insert,
            options: writeBehaviorAllOptions.filter((option) => option.value === writeBehaviorOptionValues.insert)
        }
    ] : undefined,
    copyJob: {
        updateMethod: {
            supportUpdateMethod: true,
            options: [getAppendOption()],
            updateMethodProperties: ['writeBehavior'],
            defaultUpdateMethod: UpdateMethod.Append
        },
        fullLoadBehavior: {
            supportFullLoadBehavior: true
        }
    },
    category: ['ServicesApps']
};
